var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpendCategoryEntertainment32(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DDL-CBA---Icons-Mobile",
    transform: "translate(-1614.000000, -732.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon//SpendCategory/Entertainment32"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bounding-box",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("g", {
    id: "Entertainment-03",
    transform: "translate(4.000000, 3.000000)",
    fill: "#706D6E"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ticket",
    transform: "translate(12.077077, 12.813919) rotate(45.000000) translate(-12.077077, -12.813919) translate(6.077077, 1.813919)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.31148713,1.68622977 L1.31148713,20.6862298 L3.4270994,20.6862298 C3.66959672,19.49503 4.76208024,18.6028964 6.06377023,18.6028964 C7.36546022,18.6028964 8.45794374,19.49503 8.70044106,20.6862298 L10.8160533,20.6862298 L10.8160533,1.68622977 L8.70044106,1.68622977 C8.45794374,2.87742955 7.36546022,3.7695631 6.06377023,3.7695631 C4.76208024,3.7695631 3.66959672,2.87742955 3.4270994,1.68622977 L1.31148713,1.68622977 Z M0.313770232,0.686229768 L4.37465303,0.686229768 L4.37465303,1.18622977 C4.37465303,2.05478205 5.12533633,2.7695631 6.06377023,2.7695631 C7.00220413,2.7695631 7.75288743,2.05478205 7.75288743,1.18622977 L7.75288743,0.686229768 L11.8137702,0.686229768 L11.8137702,21.6862298 L7.75288743,21.6862298 L7.75288743,21.1862298 C7.75288743,20.3176775 7.00220413,19.6028964 6.06377023,19.6028964 C5.12533633,19.6028964 4.37465303,20.3176775 4.37465303,21.1862298 L4.37465303,21.6862298 L0.313770232,21.6862298 L0.313770232,0.686229768 Z",
    id: "Combined-Shape"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpendCategoryEntertainment32);
export default __webpack_public_path__ + "static/media/spendCategoryEntertainment32.b1e514012604cf5f23652e0181c89ea4.svg";
export { ForwardRef as ReactComponent };